<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
            <!-- codeAttrVal1="Y" -->
          <c-multi-select
            codeGroupCd="REGULATION_BILL_API_CD"
            codeAttrVal2="Y"
            itemText="codeName"
            itemValue="code"
            label="관련 법규"
            name="regulationBillCds"
            @datachange="billCdChange"
            v-model="searchParam.regulationBillCds">
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
          <c-multi-select
            type="search"
            :comboItems="regulatedItems"
            itemText="regulatedItemName"
            itemValue="regulatedItemCd"
            label="규제 법규"
            name="regulatedItemCds"
            v-model="searchParam.regulatedItemCds">
          </c-multi-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="규제별 담당자 목록"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      :checkClickFlag="false"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline >
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'users'">
          <c-tag 
            :editable="editable"
            icon="person_outline"
            itemText="userName"
            itemValue="check"
            name="users" 
            v-model="props.row.users"
            @addTag="addManager(props.row)"
            @removeTag="item => removeManager(item)"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: "regul-manager",
    data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'regulationBillName' },
        ],
        columns: [
          {
            name: 'regulationBillName',
            field: 'regulationBillName',
            label: '법규',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'users',
            field: 'users',
            label: '담당자',
            align: 'left',
            type: 'custom',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        lawId: null,
        userId: null,
        regulationBillCds: [],
        regulatedItemCds: [],
      },
      regulatedItems: [],
      row: null,
      editable: true,
      listUrl: '',
      regsUrl: '',
      insertUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.chm.mail.regulManager.list.url
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;
      this.insertUrl = transactionConfig.chm.mail.mailManager.insert.url;
      this.deleteUrl = transactionConfig.chm.mail.mailManager.delete.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    billCdChange(newValue) {
      if (newValue && newValue.length > 0) {
        this.$http.url = this.regsUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          searchItems: this.$_.map(newValue, 'value')
        };
        this.$http.request((_result) => {
          if (_result.data && _result.data.length > 0) {
            let deleteItems = [];
            this.$_.forEach(this.searchParam.regulatedItemCds, item => {
              if (this.$_.findIndex(_result.data, { regulatedItemCd: item }) === -1) {
                deleteItems.push(item);
              }
            })
            if (deleteItems && deleteItems.length > 0) {
              this.$_.forEach(deleteItems, item => {
                this.$_.remove(this.searchParam.regulatedItemCds, (i) => {
                  return i === item
                })
              })
            }
          } else {
            this.searchParam.regulatedItemCds = [];
          }
          this.regulatedItems = _result.data;
        },);
      } else {
        this.searchParam.regulatedItemCds = [];
        this.regulatedItems = [];
      }
    },
    /* eslint-disable no-unused-vars */ 
    addManager(row) {
      this.row = this.$_.clone(row)
      this.popupOptions.title = '사용자 검색'; // 사용자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.row.users, { userId: item.userId }) === -1) {
            this.$_.extend(item, this.row)
            saveData.push(item)
          }
        })
        this.$http.url = this.insertUrl;
        this.$http.type = 'POST';
        this.$http.param = saveData;
        this.$http.request((_result) => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.getList();
        },);
      }
    },
    removeManager(item) {
      this.$http.url = this.$format(this.deleteUrl, item.chmMailManagerId);
      this.$http.type = 'DELETE';
      this.$http.request((_result) => {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.getList();
      },);
    }
  },
};
</script>
